(function () {
  if (window.__asmotaMainProductEnhancementsInitialized) {
    return;
  }
  window.__asmotaMainProductEnhancementsInitialized = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function initDescriptionTabs($, section) {
    $(section).find('.product-single__description ul.tabs').each(function () {
      var active;
      var content;
      var links = $(this).find('a');
      if (!links.length) {
        return;
      }

      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });

      $(this)
        .find('a')
        .off('click.petshopTabs')
        .on('click.petshopTabs', function () {
          active.removeClass('active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('active');
          content.show();
          return false;
        });
    });
  }

  function initSlickThumbs($, section, attempt) {
    attempt = attempt || 0;
    if (!$.fn || !$.fn.slick) {
      if (attempt < 20) {
        setTimeout(function () {
          initSlickThumbs($, section, attempt + 1);
        }, 200);
      }
      return;
    }

    var $section = $(section);
    var $thumbLists = $section.find('.thumbnail-list-slick.list-unstyled');
    if (!$thumbLists.length) {
      return;
    }

    $thumbLists.each(function () {
      var $list = $(this);
      if ($list.hasClass('slick-initialized')) {
        return;
      }

      var $slider = $list.closest('.thumbnail-slider');
      if ($slider.length) {
        $slider.addClass('slick-thumbs-enabling');
      }

      try {
        $list.slick({
          centerPadding: '0',
          autoplay: false,
          arrows: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          draggable: true,
          infinite: false,
          vertical: true,
          verticalScrolling: true,
          speed: 250,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                vertical: false,
                slidesToShow: 4
              }
            },
            {
              breakpoint: 750,
              settings: {
                vertical: false,
                slidesToShow: 3
              }
            }
          ]
        });

        if (!$list.data('wheelBound')) {
          $list.data('wheelBound', true);

          var lastWheelTs = 0;
          var wheelHandler = function (event) {
            var now = Date.now();
            if (now - lastWheelTs < 40) {
              return;
            }
            lastWheelTs = now;

            var deltaY = typeof event.deltaY === 'number' ? event.deltaY : 0;
            var deltaX = typeof event.deltaX === 'number' ? event.deltaX : 0;
            if (!deltaY && typeof event.wheelDelta === 'number') {
              deltaY = -event.wheelDelta;
            }

            var delta = Math.abs(deltaY) >= Math.abs(deltaX) ? deltaY : deltaX;
            if (!delta) {
              return;
            }

            var slick = $list.slick('getSlick');
            if (!slick || !slick.slideCount) {
              return;
            }

            var direction = delta > 0 ? 1 : -1;
            var current = slick.currentSlide || 0;
            var slidesToShow = slick.options && slick.options.slidesToShow ? slick.options.slidesToShow : 1;
            var maxIndex = Math.max(0, slick.slideCount - slidesToShow);

            if ((direction < 0 && current <= 0) || (direction > 0 && current >= maxIndex)) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            var stepCount = Math.min(5, Math.ceil(Math.abs(delta) / 60));
            var target = current + direction * stepCount;
            if (target < 0) {
              target = 0;
            }
            if (target > maxIndex) {
              target = maxIndex;
            }

            if (target !== current) {
              $list.slick('slickGoTo', target, true);
            }
          };

          if ($list[0] && $list[0].addEventListener) {
            $list[0].addEventListener('wheel', wheelHandler, { passive: false });
          }
        }

        if ($slider.length) {
          $slider.removeClass('slick-thumbs-enabling');
          $slider.addClass('slick-thumbs-enabled');
        }
      } catch (error) {
        if ($slider.length) {
          $slider.removeClass('slick-thumbs-enabling');
          $slider.removeClass('slick-thumbs-enabled');
        }
      }
    });
  }

  function initThreeColumnProductLayout(section) {
    var infoContainer = section.querySelector('.product__info-container--modern');
    if (!infoContainer || infoContainer.dataset.threeColumnInitialized === 'true') {
      return;
    }

    var purchaseSelectors = [
      '[id^="price-"]',
      '.product__micro-trust',
      '.product__tax',
      '.product__payment-terms-block',
      '.product__buy-buttons-block',
      '.product-com-wish',
      '[id^="Quantity-Form-"]',
      '[id^="Inventory-"]',
      '.estimate-delivery',
      '.product__type--category'
    ];

    var children = Array.prototype.slice.call(infoContainer.children);
    if (!children.length) {
      return;
    }

    var detailsColumn = document.createElement('div');
    detailsColumn.className = 'product__details-column';

    var purchaseColumn = document.createElement('aside');
    purchaseColumn.className = 'product__purchase-column';
    purchaseColumn.setAttribute('aria-label', 'Purchase options');

    children.forEach(function (child) {
      var shouldGoToPurchaseColumn = false;

      if (child && child.nodeType === 1) {
        shouldGoToPurchaseColumn = purchaseSelectors.some(function (selector) {
          return child.matches(selector);
        });
      }

      if (shouldGoToPurchaseColumn) {
        purchaseColumn.appendChild(child);
      } else {
        detailsColumn.appendChild(child);
      }
    });

    infoContainer.appendChild(detailsColumn);
    infoContainer.appendChild(purchaseColumn);

    infoContainer.dataset.threeColumnInitialized = 'true';
    infoContainer.classList.add('product__three-column-ready');
  }

  function initSection(section) {
    initThreeColumnProductLayout(section);

    if (!window.jQuery) {
      return;
    }

    var $ = window.jQuery;
    initDescriptionTabs($, section);
    initSlickThumbs($, section);
  }

  function initContext(context) {
    var root = context && context.nodeType === 1 ? context : document;

    if (root === document) {
      document.querySelectorAll('[data-main-product-enhancements="true"]').forEach(function (section) {
        initSection(section);
      });
      return;
    }

    if (root.matches && root.matches('[data-main-product-enhancements="true"]')) {
      initSection(root);
      return;
    }

    var matchedSections = root.querySelectorAll ? root.querySelectorAll('[data-main-product-enhancements="true"]') : [];
    if (matchedSections.length) {
      matchedSections.forEach(function (section) {
        initSection(section);
      });
      return;
    }

    if (root.querySelector && root.querySelector('.product__info-container--modern')) {
      initSection(root);
    }
  }

  function initAll(context) {
    initContext(context);
  }

  window.asmotaInitMainProductEnhancements = initContext;

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();